<template>
  <div
    class="card sport-card flex-fill h-100"
    role="button"
    @click="action_click"
  >
    <img
      class="card-img-top object-contain"
      :src="ruta_imagen"
      :alt="ruta_imagen_alt || 'Deporte'"
      @error="imagen_error"
    />
    <div class="card-body d-flex flex-column">
      <button class="btn btn-primary w-100 mt-2" @click.stop="action_click">
        {{ descripcion_boton }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "CardDeporte",
  props: {
    descripcion_boton: {
      type: String,
      required: true,
    },
    ruta_imagen: {
      type: String,
      required: true,
    },
    ruta_imagen_alt: {
      type: String,
      required: true,
    },
    imagen_error: {
      type: Function,
      required: true,
    },
    action_click: {
      type: Function,
      required: true,
    },
  },
};
</script>

<style scoped>
/* Asegura proporción visual de la imagen y un look agradable */
.object-contain {
  height: 180px; /* mantené el tamaño del div */
  width: 100%;
  object-fit: contain; /* NO recorta: encaja completa */
  object-position: center;
  background: #f8f9fa; /* color de fondo donde “sobran” bordes */
  padding: 8px; /* opcional, evita que toque los bordes */
  display: block; /* quita el pequeño gap inferior de las imágenes inline */
}

/* Tarjeta con un poco de vida */
.sport-card {
  transition: transform 0.12s ease, box-shadow 0.12s ease;
}
.sport-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
}

/* Accesibilidad: cursor */
.sport-card[role="button"] {
  cursor: pointer;
}
</style>
